const favourite_tv_show = `One of my favorite TV shows is a Finnish comedy series called "Luottomies.
It's a funny show that makes me laugh and feel happy.
The show is about a man named Luottomies who helps people with their problems,
but he often ends up making things worse.
He is a kind person, but he's not very good at his job, which leads to many funny situations.
The characters in the show are all very funny and interesting.
They have different personalities and make the show entertaining to watch.
The actors do a great job of bringing the characters to life and making the show enjoyable for everyone.
"Luottomies" is a show that can make anyone laugh and forget about their worries. 
It's a light-hearted series that is perfect for relaxing and having a good time.
Watching the show always brings a smile to my face and makes my day better.`;

export default favourite_tv_show;